import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { cookieUtils } from '../utils/cookies';
import { useAppDispatch } from '../store/hooks';
import { fetchUserProfile } from '../store/slices/userSlice';

const CallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleCallback = async () => {
      // Parse hash parameters (access token and expiration are in URL hash)
      // Format: #access=token&exp=date
      const hash = window.location.hash.substring(1); // Remove the '#' character
      const params = new URLSearchParams(hash);

      const accessToken = params.get('access');
      const expiresAt = params.get('exp');

      if (accessToken) {
        // Store access token in cookies
        // Note: refreshToken is now sent as http-only cookie by backend
        cookieUtils.setAccessToken(accessToken, true); // Explicitly remember social logins

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Set remember me preference for social logins (default to true)
        localStorage.setItem('login_remember_me', 'true');

        // Fetch user profile and store in Redux
        try {
          const user = await dispatch(fetchUserProfile()).unwrap();

          // Store email for remember me functionality
          if (user.email) {
            localStorage.setItem('remembered_email', user.email);
          }

          // Check if user has seen welcome screen before
          const hasSeenWelcome = localStorage.getItem(`welcome_seen_${user.id}`);

          if (hasSeenWelcome === 'true') {
            navigate('/dashboard');
          } else {
            navigate('/welcome');
          }
        } catch (error) {
          console.error('Error fetching user profile:', error);
          // Even if profile fetch fails, redirect to welcome screen
          navigate('/welcome');
        }
      } else {
        // If access token is missing, redirect to login
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate, dispatch]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-orange-50/30 to-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-800 text-lg font-medium">Processing authentication...</p>
      </div>
    </div>
  );
};

export default CallbackPage;

